(function () {

  'use strict';

  eclipseApp.controller('prepaidRefillCtrl', ['$scope', '$rootScope', '$modal', '$http', '$state', '$window', '$stateParams', '$previousState', 'commonService', 'httpService', 'prepaidAutoRefillInfoService', 'prepaidUserInfoService', 'prepaidRegisteredCCInfoService', 'retrievePrepaidPlanInfo', '$sessionStorage', function($scope, $rootScope, $modal, $http, $state, $window, $stateParams, $previousState, commonService, httpService, prepaidAutoRefillInfoService, prepaidUserInfoService, prepaidRegisteredCCInfoService, retrievePrepaidPlanInfo, $sessionStorage) {

      console.log('Inside prepaidRefillCtrl');

      $scope.$extend({

        accountDetails : commonService.accountDetails,
        selectedBAN : $stateParams.accountNumber,
        selectedCTN : $stateParams.subscriberNo,
        //selectedCTN : '6132763883',
        uuid : '00XSD245', // TODO : Need to change
        userID : '00XSD245', // TODO : Need to change
        language : 'en', // TODO : Need to change
        subscriberNumberList : [],
    	  stopPaymentResponse : '',
    	  backendErrorNotifier : false,
        planUOM : null,
        planPrice : null,
        planTerm : null,
        planfeatures : null,
        planAndAddOnInfo : null,
        autoRefillEligibility : null,
        autoRefillSubscriptionInfo : null,
        userInfo: null,
        creditCardRegistrationInfo : null,
        fidoRewardsInfo : null,
        deviceInfo : null,
        planAndAddOnInfoError : null,
        autoRefillEligibilityError : null,
        autoRefillSubscriptionInfoError : null,
        userInfoError : null,
        creditCardRegistrationInfoError : null,
        fidoRewardsInfoError : null,
        deviceInfoError : null,
        $storage : $sessionStorage,

        checkAutoRefillEligibility : function (accountNumber, subscriberNumber) {
          var promise = httpService.send(
            'v1/refill/autorefill/eligibility', // TODO : Need to change
            {
            accountNumber: accountNumber,
            ctn: subscriberNumber
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.autoRefillEligibilityError = true;
              } else {
                //alert('Got AutoRefillEligibility Successfully');
                $scope.autoRefillEligibility = result.data;
                console.log('$scope.autoRefillEligibility :: '+$scope.autoRefillEligibility);
                prepaidAutoRefillInfoService.setAutoPayPlanEligibility($scope.autoRefillEligibility.autoMSFEligibility);
                prepaidAutoRefillInfoService.setAutoRefillBalanceEligibility($scope.autoRefillEligibility.autoEXLBEligibility);
              }
            },
            function (reason) {
              $scope.autoRefillEligibilityError = true;
            }
          );
        },

        retrieveCreditCardRegistrationInfo : function (accountNumber, subscriberNumber) {
          var promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
            {
            accountNumber: accountNumber,
            ctn: subscriberNumber
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.creditCardRegistrationInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.creditCardRegistrationInfo = result.data;
                if($scope.creditCardRegistrationInfo.registrationStatus){
                  //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                  prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                  prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                  prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                }
                prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
              }
            },
            function (reason) {
              $scope.creditCardRegistrationInfoError = true;
            }
          );
        },

        retrieveUserInfo : function (accountNumber, subscriberNumber) {
          var promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/userinfo', // TODO : Need to change
            {
            accountNumber: accountNumber,
            ctn: subscriberNumber
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.userInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.userInfo = result.data;
                console.log('$scope.userInfo :: '+$scope.userInfo);
                prepaidUserInfoService.setFirstName($scope.userInfo.firstName);
                prepaidUserInfoService.setLastName($scope.userInfo.lastName);
                prepaidUserInfoService.setEmailAddress($scope.userInfo.emailAddress);
                prepaidUserInfoService.setBillingAddress($scope.userInfo.billingAddress);
              }
            },
            function (reason) {
              $scope.userInfoError = true;
            }
          );
        },

        relaunchPage : function () {
          //Fix to retrieve necessary info upon language toggle/page refresh
          if(prepaidUserInfoService.getCTN() === null || prepaidUserInfoService.getCTN() === '' || prepaidUserInfoService.getBAN() === null || prepaidUserInfoService.getBAN() === '') {
            prepaidUserInfoService.setCTN($scope.$storage.selectedCTN);
            prepaidUserInfoService.setBAN($scope.$storage.selectedBAN);
          }
          if($rootScope.userInfo){
            if(prepaidUserInfoService.getBAN() != null && prepaidUserInfoService.getBAN() != '' && prepaidUserInfoService.getBAN() != $rootScope.userInfo.selectedAccountNumber){
              $rootScope.userInfo.selectedAccountNumber = prepaidUserInfoService.getBAN();
            }
            if(prepaidUserInfoService.getCTN() != null && prepaidUserInfoService.getCTN() != '' && prepaidUserInfoService.getCTN() != $rootScope.userInfo.selectedSubscriberNo){
              $rootScope.userInfo.selectedSubscriberNo = prepaidUserInfoService.getCTN();
            }
          }
          if(!(prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag && prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag)){
            $scope.checkAutoRefillEligibility(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());
          }else{
            console.log('checkAutoRefillEligibility is being called');
            prepaidAutoRefillInfoService.setAutoPayPlanEligibility(true);
            prepaidAutoRefillInfoService.setAutoRefillBalanceEligibility(true);
          }
          $scope.retrieveUserInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());
          $scope.retrieveCreditCardRegistrationInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN());

          var stopAutoRefillPaymentResponse = prepaidAutoRefillInfoService.getStopAutoPaymentResponse();
          /*if(stopAutoRefillPaymentResponse !== '' && stopAutoRefillPaymentResponse !== null && angular.isDefined($previousState.get().state.name) && $previousState.get().state.name !== '' && $previousState.get().state.name !== null && angular.isDefined(stopAutoRefillPaymentResponse) && ($previousState.get().state.name === 'myAccount.prepaidRefill.autoPayPlan' || $previousState.get().state.name === 'myAccount.prepaidRefill.autoRefillBalance')){
            $scope.stopPaymentResponse = stopAutoRefillPaymentResponse;
          }*/
          if(stopAutoRefillPaymentResponse !== '' && stopAutoRefillPaymentResponse !== null && angular.isDefined(stopAutoRefillPaymentResponse) && angular.isDefined($rootScope.previousState) && $rootScope.previousState !== null && $rootScope.previousState !== '' && ($rootScope.previousState.name === 'myAccount.prepaidRefill.autoPayPlan' || $rootScope.previousState.name === 'myAccount.prepaidRefill.autoRefillBalance')){
            $scope.stopPaymentResponse = stopAutoRefillPaymentResponse;
          }
        }

      });

    /**
     *
     * @param state
     */
    $scope.go = function (state) {
      $state.go(state);
    };

    /**
     * tabs data for ui tabs directive
     * @type {{heading: string, subheading: string, route: string}[]}
     */

    // code added to stop pre selection of refill option
    // this will serve as a flag to prevent redirection
    $scope.moveAround = false;

    $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
      // we want to check the initial request to redirect and reject it; then we can revert the flag
      if ($scope.moveAround === false){
        event.preventDefault();
        // revert flag
        $scope.moveAround = true;
      }
    });

    $scope.tabData = [
      {
        heading: 'wireless.label.setUpAutoPayPlan',
        route: 'myAccount.prepaidRefill.autoPayPlan',
        autoRefillSubscribed: 'false',
        content: prepaidAutoRefillInfoService.getAutoPayPlanSubContent(),
        class:'tab pp-refill-margin-top-1-5',
        active: false
      },
      {
        heading: 'wireless.label.setUpAutoRefillBalance',
        route: 'myAccount.prepaidRefill.autoRefillBalance',
        autoRefillSubscribed: 'false',
        content: prepaidAutoRefillInfoService.getAutoRefillBalanceSubContent(),
        class:'tab pp-refill-margin-top-1-5',
        active: false
      },
      {
        heading: 'wireless.label.oneTimeRefill',
        route: 'myAccount.prepaidRefill.oneTimeRefill',
        class:'tab pp-refill-margin-top-1-5',
        active: false
      },
      {
        heading: 'wireless.label.redeemVoucher',
        route: 'myAccount.prepaidRefill.redeemVoucher',
        class:'tab pp-refill-margin-top-1-5',
        active: false
      }
    ];

    $scope.relaunchPage();

  }]);

})();
